import { Directive, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

/**
 * Use destroy$ as the argument to takeUntil in an rxjs pipe
 *
 * @example
 * ```ts
 *  ... .pipe(
 *    takeUntil(this.destroy$),
 *   ...
 *  )
 *  ```
 *
 */
@Directive()
export abstract class OnDestroySubject
  implements OnDestroy {

  protected readonly destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}


